<div class="maintenance-action">
  <span class="maintenance-label">{{''| i18n:question}}?</span>
  <div class="maintenance-action-txt" >{{'' | i18n: 'no'}}</div>
  <label class="switch">
    <input type="checkbox" [(ngModel)]="selectedValue" [checked]="on"
           (change)="value.emit(selectedValue)">
    <span class="slider round"></span>
  </label>
  <div class="maintenance-action-txt" style="padding-left: 37px;">{{'' | i18n: 'yes'}}</div>
</div>
